import styled from 'styled-components';
import { Search } from 'UI';

export const SearchContainer = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 0.5rem;
  justify-content: space-between;
`;

export const SwitchContainer = styled.div`
  padding-right: 0.5rem;
  display: flex;
  gap: 0.5rem;
`;

export const OrserSearchInput = styled(Search)`
  width: fit-content;
`;
